export default __webpack_public_path__ + "static/media/Foto_Oben_mobile.cb83006b.jpg";